import VisitorInfoPage from '../visitas/pages/VisitorInfoPage.vue';
import { laisPath } from '../laisRouteHelpers';

export default {
  path: laisPath('/informacoes-visitante/:visitorId'),
  component: VisitorInfoPage,
};
